import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { WebTestHeroPage } from './WebTestHeroPage'
import { WebTestLegalPage } from './WebTestLegalPage'
import { WebTestSimplePage, WebsiteAuthRedirect } from './WebTestSimplePage'
import { WebTestNotFoundPage } from './WebTestNotFoundPage'
import { SeoLandingPage } from './pages/SeoLandingPage'
import { LANDING_DOCS } from './pages/landing-content'
import { BlogIndexPage, BlogPostPage } from './blog/BlogPages'
import { GoldDirectionLandingPage } from './ads/GoldDirectionLandingPage'
import { TradeLandingPage } from './ads/TradeLandingPage'
import { isTradeLandingHost } from './ads/trade-landing-config'
import { AnalyticsBootstrap } from './seo/AnalyticsBootstrap'
import { ProductAssistant } from './ProductAssistant'
import { WebsiteAnalytics } from './WebsiteAnalytics'

function Landing({ path }: { path: keyof typeof LANDING_DOCS }) {
  return <SeoLandingPage doc={LANDING_DOCS[path]} />
}

function HomeRoute() {
  return isTradeLandingHost() ? <TradeLandingPage /> : <WebTestHeroPage />
}

function WebsiteShell() {
  const { pathname } = useLocation()
  const adsLanding = pathname.startsWith('/go/') || isTradeLandingHost()
  return (
    <>
      <AnalyticsBootstrap />
      <WebsiteAnalytics />
      {adsLanding ? null : <ProductAssistant />}
      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/about" element={<WebTestSimplePage doc="about" />} />
        <Route path="/support" element={<WebTestSimplePage doc="support" />} />
        <Route path="/contact" element={<WebTestSimplePage doc="contact" />} />
        <Route path="/login" element={<WebsiteAuthRedirect kind="login" />} />
        <Route path="/register" element={<WebsiteAuthRedirect kind="register" />} />
        <Route path="/terms" element={<WebTestLegalPage doc="terms" />} />
        <Route path="/privacy" element={<WebTestLegalPage doc="privacy" />} />
        <Route path="/cookies" element={<WebTestLegalPage doc="cookies" />} />
        <Route path="/risk-disclosure" element={<WebTestLegalPage doc="risk-disclosure" />} />
        <Route path="/gold-prediction-trading" element={<Landing path="/gold-prediction-trading" />} />
        <Route
          path="/silver-prediction-trading"
          element={<Landing path="/silver-prediction-trading" />}
        />
        <Route path="/prediction-strategies" element={<Landing path="/prediction-strategies" />} />
        <Route
          path="/how-perfect-predict-works"
          element={<Landing path="/how-perfect-predict-works" />}
        />
        <Route
          path="/mt5-trading-infrastructure"
          element={<Landing path="/mt5-trading-infrastructure" />}
        />
        <Route path="/demo-trading-account" element={<Landing path="/demo-trading-account" />} />
        <Route
          path="/funding-and-withdrawals"
          element={<Landing path="/funding-and-withdrawals" />}
        />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        {/* Ads / creative landings — register panel → Client Portal */}
        <Route path="/go/gold" element={<GoldDirectionLandingPage />} />
        <Route path="/go/trade" element={<TradeLandingPage />} />
        {/* Removed from production exposure — keep URL from serving a duplicate homepage */}
        <Route path="/web-test" element={<Navigate to="/" replace />} />
        <Route path="/404" element={<WebTestNotFoundPage />} />
        <Route path="*" element={<WebTestNotFoundPage />} />
      </Routes>
    </>
  )
}

/** Public marketing website routes only (VITE_PUBLIC_WEBSITE / website entry). */
export function WebsiteApp() {
  return <WebsiteShell />
}
